import {
  ImageProps,
  Image,
  colors,
  media,
} from "@literati/public-ui-shared-react";
import { ReactNode } from "react";
import styled from "styled-components";

const DEFAULT_IMAGE_SIZE = 100;

const Header = styled.h3`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 0.875rem;
  display: block;
  align-items: center;

  color: ${colors.inkBlack};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledImage = styled(Image)<{ $orientation: "left" | "right" }>`
  margin: auto;
  ${media.lg} {
    margin-top: 1rem;
  }
  margin-right: ${({ $orientation }) =>
    $orientation === "left" ? `-${DEFAULT_IMAGE_SIZE / 2}px` : undefined};
  margin-left: ${({ $orientation }) =>
    $orientation === "right" ? `-${DEFAULT_IMAGE_SIZE / 2}px` : undefined};
  z-index: 2;
`;

const Card = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  padding: 2rem 1.5rem;
  display: flex;
  position: relative;
  flex-direction: row;
  max-width: 100%;
`;

const CardContent = styled.div<{ $orientation: "left" | "right" }>`
  flex-direction: column;
  width: 263px;
  max-width: 100%;
  padding-left: ${({ $orientation }) =>
    $orientation === "left" ? `${DEFAULT_IMAGE_SIZE / 2}px` : undefined};
  text-align: left;
`;

const Content = styled.p`
  width: 220px;
  max-width: 100%;
`;

export interface CircleTestimonialProps {
  header: ReactNode;
  content: ReactNode;
  imageProps: Omit<ImageProps, "height" | "width">;
  imageOrientation: "left" | "right";
}
export const CircleTestimonial = ({
  header,
  content,
  imageProps,
  imageOrientation = "left",
}: CircleTestimonialProps) => {
  const image = {
    ...imageProps,
    height: DEFAULT_IMAGE_SIZE,
    width: DEFAULT_IMAGE_SIZE,
  };
  return (
    <Container>
      {imageOrientation === "left" ? (
        <StyledImage $orientation={imageOrientation} {...image} contain />
      ) : null}
      <Card>
        <CardContent $orientation={imageOrientation}>
          <Header>{header}</Header>
          <Content>{content}</Content>
        </CardContent>
      </Card>
      {imageOrientation === "right" ? (
        <StyledImage $orientation={imageOrientation} {...image} contain />
      ) : null}
    </Container>
  );
};
